/*
 * @Author: muqing
 * @Date: 2024-08-29 16:46:03
 * @LastEditors: muqing
 * @LastEditTime: 2024-08-29 17:07:48
 * @Description: 
 */
import HttpClient from '@library/httpClient_activity.js';


HttpClient.interceptors.request.use(config => {
    // 去掉用户校验
    Object.assign(config, {
        ajaxCustomHeaders: {
            headers: {},
            cb: config => {
                const deleteKeys:string[] = ['did', 'uid', 'key', 'version'];
                deleteKeys.forEach(key => delete config.headers[key]);
            }
        }
    })
    return config;
}, error => {
    return Promise.reject(error);
});


export default HttpClient;